import { Card } from '@nike/eds';
import { Close } from '@nike/nike-design-system-icons';
import { useSetAtom } from 'jotai';
import * as R from 'ramda';
import { rankingRuleTriggerModalAtom } from '../../atoms/ranking';
import { IconButton } from './IconButton';

const TriggerConcepts = ({
  data,
  onRemove,
}: {
  data: RankingRuleTriggerConcept[];
  onRemove: () => void;
}) => {
  return (
    <div className='tw-relative tw-border tw-border-gray-200 tw-rounded-full tw-py-2 tw-px-3 tw-group'>
      <div className='tw-flex tw-items-center tw-flex-wrap tw-gap-1.5'>
        {data.map((t, idx) => (
          <span
            key={`${t.id}_${idx}`}
            className='tw-bg-blue-100/70 tw-text-blue-700 tw-px-1 tw-py-0.5 tw-rounded tw-border tw-border-blue-400 tw-text-xs'
          >
            {t.name}
          </span>
        ))}
      </div>
      <IconButton
        className='tw-invisible group-hover:tw-visible tw-absolute tw-top-1 tw-right-1 tw-z-10'
        label='Remove'
        icon={<Close width={16} height={16} />}
        size='sm'
        onClick={onRemove}
        style={{ transform: 'translate(50%, -50%)' }}
      />
    </div>
  );
};

export default function TriggerConceptSection(props: {
  items: RankingRuleTriggerConcept[][];
  title: string;
  propKey: 'cascadingConcepts' | 'exactConcepts';
}) {
  const items = props.items;
  const setTriggerModal = useSetAtom(rankingRuleTriggerModalAtom);
  return (
    <div>
      <h4 className='tw-my-2'>{props.title}</h4>
      <Card className='tw-flex tw-flex-wrap tw-gap-1.5'>
        {items.map((concepts, idx) => {
          const onRemove = () => {
            setTriggerModal((modal) => {
              modal.visible = false;
              modal[props.propKey] = R.remove(idx, 1, items);
            });
          };
          const ids = concepts.map((c) => c.id);
          return (
            <TriggerConcepts
              data={concepts}
              key={`${props.propKey}_${idx}_${ids}`}
              onRemove={onRemove}
            />
          );
        })}
      </Card>
    </div>
  );
}
